var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttendee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM12.2402 11.2199C11.2868 10.0599 8.9735 9.66659 8.00016 9.66659C7.02683 9.66659 4.7135 10.0599 3.76016 11.2199C3.08016 10.3266 2.66683 9.21325 2.66683 7.99992C2.66683 5.05992 5.06016 2.66659 8.00016 2.66659C10.9402 2.66659 13.3335 5.05992 13.3335 7.99992C13.3335 9.21325 12.9202 10.3266 12.2402 11.2199ZM5.66683 6.33325C5.66683 5.03992 6.70683 3.99992 8.00016 3.99992C9.2935 3.99992 10.3335 5.03992 10.3335 6.33325C10.3335 7.62659 9.2935 8.66659 8.00016 8.66659C6.70683 8.66659 5.66683 7.62659 5.66683 6.33325Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendee);
export default __webpack_public_path__ + "static/media/Attendee.442218c2da08b23c91b95aa5d9cee161.svg";
export { ForwardRef as ReactComponent };